export class AnimalWeightsViewModel {
  constructor(
    readonly animals: number,
    readonly weight: number) {
  }

  toString(): string {
    return `Animals: ${this.animals}, Weight: ${this.weight}`;
  }
}